import React, { useState, type ReactElement, useEffect, useRef } from 'react'
import {
    Form,
    Select,
    DatePicker,
    Input,
    Space,
    type DatePickerProps,
} from 'antd'
import { connect, useDispatch } from 'react-redux'
import {
    type initialDetailsInterface,
    type CorporateHomeFormDataInterface,
    type initialState,
} from '../../../../../../Types/Client/RegisteredClients/Corporate'
import dayjs from 'dayjs'
import commonStyles from '../../../../../../Utils/Common.less'
import { GetCategoryDropDownList } from '../../../../../../Services/GroupAndPartners'
// import { validateDate } from '../../../../../../Utils/ValidateDate'

const InitialDetailsForm = (props: initialDetailsInterface): ReactElement => {
    const {
        categoryDropDownList,
        corporateTaps,
        onCategorySelect,
        onDateChange,
        form,
    } = props
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [selectedDate2, setSelectedDate2] = useState<string>('')
    const dispatch = useDispatch()
    useEffect(() => {
        onDateChange(dayjs(selectedDate).format('DD/MM/YYYY'))
    }, [selectedDate])

    const hasFetchedOnce2 = useRef(false)
    useEffect(() => {
        if (!hasFetchedOnce2.current) {
            hasFetchedOnce2.current = true
            return
        }
        GetCategoryDropDownList(dispatch)
    }, [])

    useEffect(() => {
        const initialDate = corporateTaps?.initialDetails?.tradecommencementdate
        if (initialDate !== undefined) {
            setSelectedDate(initialDate)
            form.setFieldValue('tradecommencementdate', initialDate)
        }
        const date = corporateTaps?.initialDetails?.dateofincorporation
        if (date !== undefined) {
            setSelectedDate2(date)
        }
    }, [corporateTaps?.initialDetails?.tradecommencementdate])

    const handleDateChange = (
        date: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (date !== null && date !== undefined) {
            const isoDate = date.toISOString()
            setSelectedDate(isoDate)
            form.setFieldValue('tradecommencementdate', isoDate)
            void form.validateFields()
        }
    }
    const handleDateChange2 = (
        date: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (date !== null && date !== undefined) {
            const isoDate = date.toISOString()
            setSelectedDate2(isoDate)
        }
    }
    return (
        <>
            <Form.Item<CorporateHomeFormDataInterface>
                name="corporateid"
                hidden={true}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<CorporateHomeFormDataInterface>
                name="clienttypeid"
                hidden={true}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<CorporateHomeFormDataInterface>
                label="Client Category"
                name="clientcategoryid"
                rules={[
                    {
                        required: true,
                        message: 'Please Select Client Category',
                    },
                ]}
            >
                <Select
                    allowClear
                    showSearch
                    onChange={(selectedId) => {
                        if (typeof onCategorySelect === 'function') {
                            onCategorySelect(selectedId)
                        }
                    }}
                    filterOption={(input, option) =>
                        option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase()) ?? false
                    }
                    options={[
                        { value: 0, label: 'Please Select' },
                        ...categoryDropDownList,
                    ]}
                    defaultValue={1}
                />
            </Form.Item>

            <Form.Item<CorporateHomeFormDataInterface>
                label="Date of Incorporation"
                name="DateofIncorporation"
            >
                <Space direction="vertical" size={12}>
                    <DatePicker
                        format="DD/MM/YYYY"
                        className={commonStyles.dateWidth}
                        value={
                            selectedDate2?.length > 0
                                ? dayjs(selectedDate2)
                                : null
                        }
                        onChange={(date, dateString) => {
                            handleDateChange2(date, dateString)
                        }}
                        disabled
                    />
                </Space>
            </Form.Item>
            <Form.Item<CorporateHomeFormDataInterface>
                label="Company Trading Name"
                name="companytradingname"
                initialValue={corporateTaps?.initialDetails?.companytradingname}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item<CorporateHomeFormDataInterface>
                label="Trade Commencement Date"
                name="tradecommencementdate"
                // rules={[
                //     {
                //         validator: async (_, value) =>
                //             await validateDate(value),
                //     },
                // ]}
            >
                <Space direction="vertical" size={12}>
                    <DatePicker
                        value={
                            selectedDate?.length > 0
                                ? dayjs(selectedDate)
                                : null
                        }
                        format="DD/MM/YYYY"
                        className={commonStyles.dateWidth}
                        onChange={(date, dateString) => {
                            handleDateChange(date, dateString)
                        }}
                        allowClear
                    />
                </Space>
            </Form.Item>

            <Form.Item<CorporateHomeFormDataInterface>
                label="Expected Turn Over"
                name="turnover"
                rules={[
                    {
                        pattern: /^\d{1,15}(\.\d{1,5})?$/,
                        message:
                            'Expected Turn Over must be up to 15 digits and optionally include up to 5 decimal places!',
                    },
                ]}
            >
                <Input allowClear maxLength={21} />
            </Form.Item>
            <Form.Item<CorporateHomeFormDataInterface>
                label="Authentication Code"
                name="authenticationcode"
            >
                <Input allowClear maxLength={20} />
            </Form.Item>
        </>
    )
}

const mapStateToProps = (state: any): initialState => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
    }
}

export default connect(mapStateToProps)(InitialDetailsForm)
